module.exports = {
  header: {
    langList: {
      en: 'English',
      zh: '简体中文',
      kr: '한국어'
    }
  }
}



// WEBPACK FOOTER //
// ./src/i18n/base.js